<template>
  <div class="">
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="35%"
      center
      class="ne-oppop"
    >
      <div class="bg-primary p-4 flex justify-between items-center">
        <h2 class="text-white fsize14 my-0">Email Template</h2>
        <feather-icon
          icon="XIcon"
          svgClasses="w-4 h-4"
          class="cursor-pointer text-white"
          @click="
            () => {
              centerDialogVisible = false;
            }
          "
        />
      </div>
      <div class="p-4 items-center">
        <div class="flex justify-center w-full">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
            class="new-height"
          />
        </div>

        <p class="fsize14 text-dark text-center font-medium my-4">
          Customized Email Template is available only for other BRAINED's
          Subscription Plans. Please upgrade to other plan to access this
          feature
        </p>

        <div class="flex w-full mt-4 gap-2">
          <vs-button
            color="primary"
            class="bg-primary sm-button w-full"
            @click="
              () => {
                centerDialogVisible = false;
                this.$router.push({ name: 'plans-vue' });
              }
            "
            >Upgrade</vs-button
          >

          <vs-button
            color="secondary"
            class="bg-secondary sm-button w-full"
            @click="centerDialogVisible = false"
            >Cancel</vs-button
          >
        </div>
      </div>
    </el-dialog>
    <el-drawer
      title=""
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="text-xl Add Products text-white">
          Email Template
        </h3></template
      >
      <Templatedrawer @apiCall="getAll" :drawer="drawer" />
    </el-drawer>
    <el-dialog :visible.sync="centerDialogemail" width="35%" center>
      <template slot="title"
        ><h5 class="text-white text-lg">Template</h5></template
      >
      <div>
        <div class="bg-3a3a3a p-8 rounded-10px" v-if="templateId === 0">
          <div class="rounded-6px bg-f4f5f6 flex justify-center h-full w-full">
            <img
              :src="
                this.image1Source
                  ? image1Source
                  : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
              "
              class="w-full h-full rounded-10px h150px object-cover"
              alt="image1"
            />
          </div>

          <div class="mt-4">
            <p class="text-white" v-html="body1"></p>

            <p class="text-white mb-1">Thankyou,</p>
            <p class="text-white">
              {{ this.selectedProject.displayName }}
            </p>
          </div>

          <div class="mt-10">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
              alt="instagram"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
              alt="youtube"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
              alt="facebook"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
              alt="twitter"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
              alt="whatsapp"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
              alt="linkedin"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
          </div>
        </div>

        <!-- Email Template 2 -->
        <div class="bg-3a3a3a p-8 rounded-10px" v-if="templateId === 1">
          <div class="rounded-6px bg-f4f5f6 h-32">
            <img
              :src="
                this.image1Source
                  ? image1Source
                  : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
              "
              class="w-full rounded-md object-cover h-full"
              alt="image1"
            />
          </div>

          <div class="mt-4">
            <p class="text-white" v-html="body1"></p>

            <p class="text-white mb-1">Thankyou,</p>
            <p class="text-white">
              {{ this.selectedProject.displayName }}
            </p>
          </div>

          <div class="grid grid-cols-3 gap-3 mt-2">
            <div class="rounded-6px bg-f4f5f6 h-95px">
              <img
                :src="
                  this.image2Source
                    ? image2Source
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                "
                class="w-full rounded-md object-cover h-full"
                alt="image2"
              />
            </div>
            <div class="rounded-6px bg-f4f5f6 h-95px">
              <img
                :src="
                  this.image3Source
                    ? image3Source
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                "
                class="w-full rounded-md object-cover h-full"
                alt="image3"
              />
            </div>
            <div class="rounded-6px bg-f4f5f6 h-95px">
              <img
                :src="
                  this.image4Source
                    ? image4Source
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                "
                class="w-full rounded-md object-cover h-full"
                alt="image4"
              />
            </div>
          </div>

          <div class="mt-12">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
              alt="instagram"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
              alt="youtube"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
              alt="facebook"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
              alt="twitter"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
              alt="whatsapp"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
              alt="linkedin"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
          </div>
        </div>

        <!-- Email Template 3 -->
        <div class="bg-3a3a3a p-8 rounded-10px" v-if="templateId === 2">
          <div class="rounded-6px bg-f4f5f6 h-32">
            <img
              :src="
                this.image1Source
                  ? image1Source
                  : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
              "
              class="w-full rounded-md object-cover h-full"
              alt="image1"
            />
          </div>

          <div class="mt-6">
            <div class="flex">
              <div class="w-1/4">
                <div class="rounded-6px bg-f4f5f6 h-24">
                  <img
                    :src="
                      this.image2Source
                        ? image2Source
                        : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                    "
                    class="w-full rounded-md object-cover h-full"
                    alt="image2"
                  />
                </div>
              </div>

              <div class="w-3/4 pl-4">
                <p class="text-white fsize12" v-html="body1"></p>
              </div>
            </div>

            <div class="flex mt-6">
              <div class="w-1/4">
                <div class="rounded-6px bg-f4f5f6 h-24">
                  <img
                    :src="
                      this.image3Source
                        ? image3Source
                        : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                    "
                    class="w-full rounded-md object-cover h-full"
                    alt="image3"
                  />
                </div>
              </div>

              <div class="w-3/4 pl-4">
                <p class="text-white fsize12" v-html="body2"></p>
              </div>
            </div>
            <div class="mt-6">
              <p class="text-white mb-1">Thankyou,</p>
              <p class="text-white">
                {{ this.selectedProject.displayName }}
              </p>
            </div>
          </div>

          <div class="mt-10">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
              alt="instagram"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
              alt="youtube"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
              alt="facebook"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
              alt="twitter"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
              alt="whatsapp"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
              alt="linkedin"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
          </div>
        </div>
        <!-- Email Template 4 -->

        <div class="bg-3a3a3a p-8 rounded-10px" v-if="templateId === 3">
          <div class="rounded-6px bg-f4f5f6 h-32">
            <img
              :src="
                this.image1Source
                  ? image1Source
                  : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
              "
              class="w-full rounded-md object-cover h-full"
              alt="image1"
            />
          </div>
          <div class="grid grid-cols-3 gap-3 mt-4">
            <div class="rounded-6px bg-f4f5f6 h-95px">
              <img
                :src="
                  this.image2Source
                    ? image2Source
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                "
                class="w-full rounded-md object-cover h-full"
                alt="image2"
              />
            </div>
            <div class="rounded-6px bg-f4f5f6 h-95px">
              <img
                :src="
                  this.image3Source
                    ? image3Source
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                "
                class="w-full rounded-md object-cover h-full"
                alt="image3"
              />
            </div>
            <div class="rounded-6px bg-f4f5f6 h-95px">
              <img
                :src="
                  this.image4Source
                    ? image4Source
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                "
                class="w-full rounded-md object-cover h-full"
                alt="image4"
              />
            </div>
          </div>
          <div class="mt-4">
            <p class="text-white" v-html="body1"></p>

            <p class="text-white mb-1">Thankyou,</p>
            <p class="text-white">
              {{ this.selectedProject.displayName }}
            </p>
          </div>

          <div class="mt-10">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/Instagram.png"
              alt="instagram"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/youtube.png"
              alt="youtube"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/facebook.png"
              alt="facebook"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />

            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/twitter.png"
              alt="twitter"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/whatsapp.png"
              alt="whatsapp"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/social/linkedin.png"
              alt="linkedin"
              class="w-4 mr-4 h-4 object-contain cursor-pointer"
            />
          </div>
        </div>
      </div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Email Templates
          </h2>
        </div>
      </div>
    </div>
    <div class="p-8 menucontrol-scroll fixed-top">
      <div class="flex items-center gap-2 justify-left">
        <div class="mb-8 w-3/5">
          <p class="mb-0 font-medium">Search by Name</p>
          <div v-if="type == 'Custom'" class="flex items-center mt-2 relative">
            <el-input
              placeholder="Please input"
              v-model="templateName2"
              maxlength="50"
              class="rounded-none"
            ></el-input>
            <div class="absolute top-2 right-10px mt-1">
              <feather-icon icon="SearchIcon" class="" />
            </div>
          </div>
          <div v-if="type == 'Default'" class="flex items-center mt-2 relative">
            <el-input
              placeholder="Please input"
              v-model="templateName"
              maxlength="50"
              class="rounded-none"
            ></el-input>
            <div class="absolute top-2 right-10px mt-1">
              <feather-icon icon="SearchIcon" class="" />
            </div>
          </div>
        </div>
        <div class="w-1/4 mb-28">
          <div class="w-full">
            <p class="mb-0 font-medium">Search by Type</p>
            <el-select
              v-model="type"
              placeholder=""
              class="w-full border-2 mt-2 rounded-lg"
            >
              <el-option
                v-for="item in types"
                :key="item.label"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <vs-button
          v-if="type == 'Custom'"
          @click="handleClick('templates')"
          variant="primary"
          class="rounded-log bg-primary border-0 text-white mt-0 font-semibold mt-28 sm-fsize14"
        >
          Add New
        </vs-button>
      </div>
      <div v-if="type == 'Default'" class="mb-12">
        <div class="w-full p-5 bg-white mb-8">
          <h2 class="text-xl mb-0 font-semibold">Default Email Template</h2>
        </div>

        <div class="grid grid-cols-3 gap-8">
          <div
            class="p-6 elshadow bg-white border-round relative"
            v-for="(i, index) in this.defaultEmailTemps"
            :key="index"
          >
            <div class="flex justify-between items-center">
              <div class="flex items-center gap-2">
                <p
                  class="bg-primary text-white w-10 h-10 flex justify-center items-center rounded-lg mb-0"
                >
                  {{ index + 1 }}
                </p>
                <p class="text-black font-semibold mb-0">
                  {{ i.templateName }}
                </p>
                <!-- <div class="p-1 rounded-full flex items-center justify-center">
                  <el-tag
                    size="mini"
                    class="rounded-full text-sm text-dark px-3 h-6"
                    >Default</el-tag
                  >
                </div> -->
              </div>
            </div>

            <div class="mt-6">
              <div class="flex items-center gap-2">
                <p class="text-black font-semibold">Subject:</p>
                <span class="text-8f8f8f font-medium">{{ i.subject }}</span>
              </div>
              <!-- <p class="text-black font-semibold mt-4">Email Body:</p>
              <span class="text-8f8f8f font-medium">{{ i.emailBody }}</span> -->
              <!-- <p class="text-8f8f8f font-medium mt-4">
              To enrol, click on link below
            </p>
            <p class="text-8f8f8f font-medium mt-2">1</p> -->
            </div>
            <div class="absolute top-0 right-0 m-3">
              <feather-icon
                @click="handleDetails(i)"
                icon="EyeIcon"
                class="cursor-pointer"
                svgClasses="w-5 h-5"
              />
            </div>
            <!-- <p class="text-black font-semibold mt-3">Examaple:</p>
          <p class="text-8f8f8f font-medium">
            hello, this a gental you to enroll for the webinar on Brained
            Reseller Program. a gental you to enroll for the webinar on Brained
            Reseller Program.
          </p> -->
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="
              (value) => {
                currentPage = value;
                getDefaultEmailTemplates();
              }
            "
            :per-size="perPage2"
            :total="totalUsers2"
          >
          </el-pagination>
        </div>
      </div>
      <!-- default card -->

      <div v-if="type == 'Custom'" class="mb-12">
        <div class="w-full p-5 bg-white mb-8">
          <h2 class="text-xl mb-0 font-semibold">Custom Email Template</h2>
        </div>
        <div class="grid grid-cols-3 gap-4">
          <div
            class="bg-white border-round"
            v-for="data in emailTemplates"
            :key="data._id"
          >
            <div class="bg-white p-6 relative border-btm">
              <div class="flex justify-between items-center">
                <div class="flex items-center gap-2">
                  <p
                    class="bg-primary text-white w-10 h-10 flex justify-center items-center rounded-lg mb-0"
                  >
                    1
                  </p>
                  <p class="text-black font-semibold mb-0">
                    {{ data.templateName }}
                  </p>
                  <feather-icon
                    svgClasses="w-4 h-4"
                    class="text-white flex"
                    icon="CheckIcon"
                  />
                </div>
              </div>

              <div class="mt-6">
                <div class="flex items-center gap-2">
                  <p class="text-black font-semibold">Subject:</p>
                  <span class="text-8f8f8f font-medium">{{
                    data.subject
                  }}</span>
                </div>
                <!-- <div class="flex items-center gap-2 mt-2">
                  <p class="text-black font-semibold">SenderId:</p>
                  <p>{{ data.senderId ? data.senderId.email : "" }}</p>
                </div> -->

                <!-- <div class="flex items-center">
                  <p class="text-black font-semibold mt-2">Email Body:</p>

                  <p
                    class="text-8f8f8f font-medium mt-2 pl-2"
                    v-html="data.body"
                  ></p>
                </div> -->
              </div>
              <div class="absolute top-0 right-0 m-3">
                <feather-icon
                  @click="handleDetails(data)"
                  icon="EyeIcon"
                  class="cursor-pointer"
                  svgClasses="w-5 h-5"
                />
              </div>
            </div>

            <div class="p-6">
              <el-steps
                v-if="data.status !== 'rejected'"
                class="cust-step"
                :space="200"
                :active="
                  data.canUse == true
                    ? 4
                    : data.status == 'pending'
                    ? 1
                    : data.status == 'approved'
                    ? 2
                    : 1
                "
                finish-status="success"
              >
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Processed"
                ></el-step>
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Approval Status"
                ></el-step>
                <el-step
                  icon="el-icon-stopwatch"
                  class="cust-fsize12"
                  title="Integration"
                ></el-step>
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Delivered"
                ></el-step>
              </el-steps>
              <el-steps
                v-if="data.status == 'rejected'"
                class="cust-step"
                :space="200"
                :active="0"
                process-status="error"
              >
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Rejected"
                ></el-step>
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Approval Status"
                ></el-step>
                <el-step
                  icon="el-icon-stopwatch"
                  class="cust-fsize12"
                  title="Integration"
                ></el-step>
                <el-step
                  class="cust-fsize12"
                  icon="el-icon-stopwatch"
                  title="Delivered"
                ></el-step>
              </el-steps>
            </div>
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="
              (value) => {
                currentPage = value;
                getAll();
              }
            "
            :per-size="perPage"
            :total="totalUsers"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const debounce = function debounce(func, wait = 800) {
  let debounceTimer;
  return function (...args) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const context = this;
    debounceTimer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};
import { mapState } from "vuex";
import Template from "../Template.vue";
import Templatedrawer from "./components/Template-drawer.vue";
export default {
  components: {
    Templatedrawer,
    Template,
  },
  data() {
    return {
      templateId: "",
      taskList: [],
      centerDialogemail: false,
      drawer: false,
      emailTemplates: [],
      centerDialogVisible: false,
      defaultEmailTemps: [],
      totalUsers: 0,
      currentPage: 1,
      perPage: 10,
      templateName: "",
      templateName2: "",
      totalUsers2: 0,
      currentPage2: 1,
      perPage2: 10,
      type: "",
      types: [
        {
          label: "Default",
        },
        {
          label: "Custom",
        },
      ],
    };
  },
  watch: {
    templateName2: debounce(async function () {
      this.getAll();
    }),
    templateName: debounce(async function () {
      this.getDefaultEmailTemplates();
    }),
    type(val) {
      if (val) {
        this.$store.commit("controlCenter/EMAIL_TYPE", this.type);
      }
    },
  },
  mounted() {
    this.getAll();
    this.getDefaultEmailTemplates();
    this.getTaskList();
  },
  computed: {
    ...mapState("user", { selectedProject: "selectedProject" }),
    ...mapState("admin", ["selectedPlan"]),
    ...mapState("controlCenter", ["emailType"]),
    ...mapState("defaultTemplates", ["EMAIL_TEMPLATES"]),
  },
  methods: {
    async getTaskList() {
      return new Promise(async (resolve, reject) => {
        try {
          // const { data } = await Repository.post(
          //   "/zoho/projects/tasks/tasklist"
          // );
          // console.log(data);

          const { data } = await this.$store.dispatch("builder/getTasklist", {
            // projectName: "testApplication1",
            projectName: process.env.VUE_APP_COMMUNITY_NAME,
          });

          this.taskList = data.map((x) => ({
            text:
              x.name == "Sprint 0" || x.name == "Version 0"
                ? "Default"
                : x.name,
            value: x,
          }));

          // console.log(this.taskList);
          this.$store.commit("marcom/GET_TASK_LIST", {
            key: "taskListUsers",
            value: this.taskList[0].value,
          });

          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    sidebarOpen() {
      if (this.selectedPlan[0].subscription.name === "Free") {
        this.centerDialogVisible = true;
      } else {
        this.drawer = true;
      }
    },
    async getAll() {
      let payload = {
        paginated: true,
        perPage: this.perPage,
        page: this.currentPage,
      };
      if (this.templateName2) {
        Object.assign(payload, { templateName: this.templateName2 });
      }
      let data = await this.$store.dispatch("controlCenter/getAll", payload);
      this.emailTemplates = data.data.recordData;
      this.totalUsers = data.data.recordLength;
      this.drawer = false;
      this.type = this.emailType;
      // console.log(data);
    },
    async getDefaultEmailTemplates() {
      let payload = {
        isDeleted: false,
        paginated: true,
        perPage: this.perPage2,
        page: this.currentPage2,
      };
      if (this.templateName) {
        Object.assign(payload, { templateName: this.templateName });
      }
      let data = await this.$store.dispatch(
        "defaultTemplates/getEmails",
        payload
      );
      this.defaultEmailTemps = data.data.recordData;
      this.totalUsers2 = data.data.recordLength;
    },
    handleDetails(item) {
      console.log(item, "HelloMa");
      this.centerDialogemail = true;
      this.templateId = item.templateId;
      if (this.templateId === 0) {
        this.image1Source = `${this.$imageURL}` + "/" + item.image1;
        this.body1 = item.body1;
        this.status = item.status;
        this.reason = item.reason;
      }
      if (this.templateId === 1) {
        this.image1Source = `${this.$imageURL}` + "/" + item.image1;
        this.image2Source = `${this.$imageURL}` + "/" + item.image2;
        this.image3Source = `${this.$imageURL}` + "/" + item.image3;
        this.image4Source = `${this.$imageURL}` + "/" + item.image4;
        this.body1 = item.body1;
        this.body2 = item.body2;
        this.status = item.status;
        this.reason = item.reason;
      }
      if (this.templateId === 2) {
        this.image1Source = `${this.$imageURL}` + "/" + item.image1;
        this.image2Source = `${this.$imageURL}` + "/" + item.image2;
        this.image3Source = `${this.$imageURL}` + "/" + item.image3;

        this.body1 = item.body1;
        this.body2 = item.body2;
        this.status = item.status;
        this.reason = item.reason;
      }
      if (this.templateId === 3) {
        this.image1Source = `${this.$imageURL}` + "/" + item.image1;
        this.image2Source = `${this.$imageURL}` + "/" + item.image2;
        this.image3Source = `${this.$imageURL}` + "/" + item.image3;
        this.image4Source = `${this.$imageURL}` + "/" + item.image4;
        this.body1 = item.body1;
        this.status = item.status;
        this.reason = item.reason;
      }
    },
  },
};
</script>
